<template>
  <div class="LoginRegisterView view">
    <LoginRegisterBackground />
    <div class="LoginRegisterView__logo animated fadeIn">
      <img class="logo__image"
           :src="require('@/assets/images/loginRegisterImages/logo-call-web.png')"
      >
    </div>
    <div class="LoginRegisterView__form">
      <ShCard theme="dark"
              title="Aktywacja konta"
              :is-loading="$store.getters['authorization/isWaitingForAuthorisation']"
              height="150px"
      >
        <template slot="content">
          <div class="LoginRegisterView__login">
            <div class="LoginRegisterView__error">
              Konto nie zostało aktywowane
            </div>
            <div class="LoginRegisterView__title">
              Prawdpodobnie link stracił ważność.
            </div>
          </div>
        </template>
      </ShCard>
    </div>
  </div>
</template>

<script>
import ShCard from '@/components/Helpers/ShCard';
import LoginRegisterBackground from '@/components/Common/LoginRegisterBackground';

export default {
  name: 'LoginRegister',

  components: {
    ShCard,
    LoginRegisterBackground,
  },

  methods: {
    handleLogin() {
      const gateway = '78a35bcb-3063-41e8-be99-c6f69fb1c0d7';
      this.$auth.loginToPlatform({ gateway, lang: 'pl' });
    },
  },
};
</script>

<style lang="sass">
.LoginRegisterView
  align-items: center
  display: flex
  flex-direction: column
  height: 100%
  justify-content: center
  position: relative
  width: 100%

  &__logo
    align-items: center
    display: flex
    justify-content: center
    margin-bottom: 20px

    .logo__image
      width: 350px

  &__form
    margin-top: 40px
    width: 587px

  &__login
    margin-bottom: 45px

  &__error
    color: $red
    font-size: 18px
    font-weight: 700
    margin-bottom: 40px
    margin-top: 20px
    text-align: center

  &__title
    font-size: 14px
    font-weight: 300
    margin-bottom: 10px
    text-align: center

    .title__hint
      color: $app-description-color
      display: block

  .ShCard
    background: #24262D
    border-radius: 15px
    box-shadow: -2px 7px 31px 0 rgba(34,31,31,0.5)
    padding: 10px 40px
    z-index: 1

    &__column--left
      padding-right: 0
      text-align: center
      width: 100%
</style>
